import { deviceConstants } from '../Constants';
import { deviceService, userService } from '../../services';
import { alertActions } from './';

export const deviceActions = {
    getUserDevices,
    updateDevice,
    getUserClusters,
    getClusterDevices,
    getClusterDeviceData,
    getClusterDevicesData,
    getMoreClusterData
};

function getUserDevices() {
    return dispatch => {
        dispatch(request());
        dispatch(alertActions.clear());

        userService.getUserDevices()
        .then(
            data => { 
                dispatch(success(data));
            },
            error => {
                dispatch(failure());
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() { return { type: deviceConstants.REQUEST_USER_DEVICES } }
    function success(data) { return { type: deviceConstants.UPDATE_DEVICE_LIST, data } }
    function failure() { return { type: deviceConstants.UPDATE_DEVICE_LIST, data: null } }
}

function updateDevice(deviceId, queryDateRange) {
    return dispatch => {
        dispatch(request());
        dispatch(alertActions.clear());

        deviceService.updateDevice(deviceId, queryDateRange)
        .then(
            data => { 
                dispatch(success(data));
            },
            error => {
                dispatch(failure());
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() { return { type: deviceConstants.GET_DEVICE_DATA } }
    function success(data) { return { type: deviceConstants.UPDATE_DEVICE_DATA, data } }
    function failure() { return { type: deviceConstants.UPDATE_DEVICE_DATA, data: null } }
}

// Clusters
function getUserClusters() {
    return dispatch => {
        dispatch(request());
        dispatch(alertActions.clear());

        userService.getUserClusters()
        .then(
            data => { 
                dispatch(success(data))
            },
            error => {
                dispatch(failure());
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() { return { type: deviceConstants.REQUEST_USER_CLUSTERS } }
    function success(data) { return { type: deviceConstants.UPDATE_CLUSTER_LIST, data } }
    function failure() { return { type: deviceConstants.FAIL_CLUSTER_LIST } }
}

function getClusterDevices(cluster, clusterID, queryDateRange, weekStart) {
    return dispatch => {
        dispatch(request());
        dispatch(alertActions.clear());

        userService.getUserClusterDevices(clusterID)
        .then(
            data => { 
                dispatch(devicesSuccess(cluster, data))
                // Get device data
                //console.log(data);
                let deviceIDs = '';
                for(let i = 0; i < data.devices.length; i++){
                    if (i > 0)
                        deviceIDs += ',';
                    deviceIDs += data.devices[i].id;
                }
                deviceService.getDevicesData(deviceIDs, queryDateRange)
                .then(
                    data => {
                        //console.log(data);
                        for(let i = 0; i < data.devices.length; i++){
                            const stats = deviceService.calcStats(
                                data.devices[i].data, weekStart);
                            dispatch(dataSuccess(cluster, i, data.devices[i].data, stats))
                        } 
                    },
                    error => {
                        for(let i = 0; i < data.devices.length; i++){
                            dispatch(dataFailure(cluster, i));
                        }
                        dispatch(alertActions.error(error));
                    }
                );
            },
            error => {
                dispatch(devicesFailure(cluster));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() { return { type: deviceConstants.REQUEST_CLUSTER_DEVICES } }
    function devicesSuccess(cluster, data) { 
        return { 
            type: deviceConstants.UPDATE_CLUSTER_DEVICES, 
            cluster, 
            data 
        } 
    }
    function devicesFailure(cluster) { 
        return { 
            type: deviceConstants.FAIL_CLUSTER_DEVICES, 
            cluster
        } 
    }
    function dataSuccess(cluster, device, data, stats) { 
        return { 
            type: deviceConstants.UPDATE_CLUSTER_DEVICE_DATA, 
            cluster, 
            device,
            data,
            stats 
        } 
    }
    function dataFailure(cluster, device) { 
        return { 
            type: deviceConstants.FAIL_CLUSTER_DEVICE_DATA, 
            cluster,
            device
        } 
    }
}

function getClusterDeviceData(cluster, device, deviceID, queryDateRange, weekStart) {
    return dispatch => {
        dispatch(request());
        dispatch(alertActions.clear());

        deviceService.updateDevice(deviceID, queryDateRange)
        .then(
            data => { 
                const stats = deviceService.calcStats(data.data, weekStart);
                dispatch(success(cluster, device, data.data, stats))
            },
            error => {
                dispatch(failure(cluster, device));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() { return { type: deviceConstants.REQUEST_CLUSTER_DEVICE_DATA } }
    function success(cluster, device, data, stats) { 
        return { 
            type: deviceConstants.UPDATE_CLUSTER_DEVICE_DATA, 
            cluster, 
            device,
            data,
            stats 
        } 
    }
    function failure(cluster) { 
        return { 
            type: deviceConstants.FAIL_CLUSTER_DEVICE_DATA, 
            cluster,
            device
        } 
    }
}

function getClusterDevicesData(cluster, deviceIDs, queryDateRange, weekStart) {
    return dispatch => {
        dispatch(request());
        dispatch(alertActions.clear());

        deviceService.getDevicesData(deviceIDs, queryDateRange)
        .then(
            data => {
                console.log(data); 
                //const stats = deviceService.calcStats(data.data, weekStart);
                //dispatch(success(cluster, device, data.data, stats))
            },
            error => {
                //dispatch(failure(cluster, device));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() { return { type: deviceConstants.REQUEST_CLUSTER_DEVICE_DATA } }
    // function success(cluster, device, data, stats) { 
    //     return { 
    //         type: deviceConstants.UPDATE_CLUSTER_DEVICE_DATA, 
    //         cluster, 
    //         device,
    //         data,
    //         stats 
    //     } 
    // }
    // function failure(cluster) { 
    //     return { 
    //         type: deviceConstants.FAIL_CLUSTER_DEVICE_DATA, 
    //         cluster,
    //         device
    //     } 
    // }
}

function getMoreClusterData(clusterId, cluster, queryDateRange) {
    return dispatch => {
        dispatch(request());
        dispatch(alertActions.clear());

        // Get device data
        //console.log(data);
        let deviceIDs = '';
        for(let i = 0; i < cluster.devices.length; i++){
            if (i > 0)
                deviceIDs += ',';
            deviceIDs += cluster.devices[i].id;
        }
        deviceService.getDevicesData(deviceIDs, queryDateRange)
        .then(
            data => {
                //console.log(data);
                for(let i = 0; i < data.devices.length; i++){
                    const stats = deviceService.updateStats(data.devices[i].data);
                    dispatch(updateSuccess(clusterId, i, data.devices[i].data, stats))
                } 
            },
            error => {
                for(let i = 0; i < cluster.devices.length; i++){
                    dispatch(updateFailure(cluster, i));
                }
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() { return { type: deviceConstants.REQUEST_MORE_CLUSTER_DATA } }
    function updateSuccess(cluster, device, data, stats) { 
        return { 
            type: deviceConstants.UPDATE_MORE_CLUSTER_DATA, 
            cluster, 
            device,
            data,
            stats 
        } 
    }
    function updateFailure(cluster) { 
        return { 
            type: deviceConstants.FAIL_MORE_CLUSTER_DATA, 
            cluster
        } 
    }
}

